module.exports = __webpack_public_path__ + "components/patterns/footer/social-icons/yt_icon_mono_light.svg";